<div [formGroup]="form" *ngIf="form">
  <app-salary-matrix *ngIf="!isJobmatch" [salaryMatrix]="salaryMatrix" [order]="order" [countryISO]="countryISO"></app-salary-matrix>

  <div *ngIf="!isJobmatch" fxLayout="row" fxLayoutGap="16px" class="additional-salary-settings">
    <mat-form-field appearance="outline" fxFlex="66">
      <mat-label>{{'ORDER.ADDITIONAL_SALARY_COMMENT' | translate}}<app-field-destination field="salaryDescription"></app-field-destination></mat-label>
      <textarea matInput [formControl]="salaryMatrix.get('description')" rows="6" type="text"></textarea>
    </mat-form-field>

    <div fxLayout="column" fxFlex="calc(33%-8px)" >
      <mat-label class="checkbox-title"> {{'ORDER.SALARY_SETTINGS' | translate }}</mat-label>
      <mat-checkbox color="primary" [formControl]="salaryMatrix.get('passDescriptionToTemplate')">{{'ORDER.INCLUDE_DESCRIPTION_IN_ORDER' | translate}}</mat-checkbox>
      <mat-checkbox color="primary" formControlName="canIncreaseSalary">{{'ORDER.CAN_INCREASE_SALARY' | translate}}<app-field-destination field="canIncreaseSalary"></app-field-destination></mat-checkbox>
      <mat-checkbox color="primary" formControlName="canGetBonuses">{{'ORDER.CAN_ACCESS_ACCESSORIES' | translate}}<app-field-destination field="canGetBonuses"></app-field-destination></mat-checkbox>
    </div>
  </div>

  <div *ngIf="!isJobmatch" style="border-bottom: 1px solid; border-color: rgba(0,0,0,.16);margin-bottom: 32px;">
  <!--  <span class="periods-header">{{'PERIODS' | translate }}</span>-->
  </div>

  <div fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="column" class="periods-container" fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="start start" *ngFor="let period of periods; let i = index; let $last=last" style="width: 100%; background-color: rgba(0,0,0,.0)">
          <app-order-period
            [period]="{period: period, index: i}"
            [periodsCount]="periods.length"
            [isJobmatch]="isJobmatch"
            [planType]="planType"
            (hasError)="onError($event)"
            (removed)="onRemove(period, $event)"
            (change)="onPeriodChange()"
            (changeIsIndefinite)="
              isIndefinite = $event;
              !$event ? form.get('indefiniteInfoControl').disable() : form.get('indefiniteInfoControl').enable();
              fillIndefiniteField($event);
              ordersService.isIndefiniteSubject.next($event)
            "
          ></app-order-period>
          <div *ngIf="!isJobmatch" class="add-period-slot">
            <ng-container *ngIf="$last" [ngTemplateOutlet]="addPeriodBtn"></ng-container>
          </div>
        </div>

        <div *ngIf="!periods.length && !isJobmatch" fxLayout="row" fxLayoutAlign="end start">
          <div class="add-period-slot">
            <ng-container [ngTemplateOutlet]="addPeriodBtn"></ng-container>
          </div>
        </div>
    </div>

    <ng-template #addPeriodBtn>
      <button *ngIf="!isJobmatch" [disabled]="isIndefinite" mat-icon-button (click)="addPeriod()">
        <mat-icon>add</mat-icon>
      </button>
    </ng-template>

    <div *ngIf="!isJobmatch" fxLayout="row" fxFlex="33">
      <div fxLayout="column" fxLayoutAlign="center flex-start" fxFlex="50">
        <mat-form-field class="new-indefinite" appearance="outline">
          <mat-label>{{'ORDER.TOTAL_SHORTAGE' | translate}}<app-field-destination field="shortage"></app-field-destination></mat-label>
          <input formControlName="shortage" matInput>
        </mat-form-field>

        <mat-form-field class="new-indefinite other-info" appearance="outline">
          <mat-label>{{'INDEFINITE_INFO' | translate}}<app-field-destination field="indefiniteOrderInfo"></app-field-destination></mat-label>
          <textarea [disabled]="!isIndefinite" formControlName="indefiniteInfoControl" matInput></textarea>
        </mat-form-field>
      </div>

      <div fxLayout="column" fxLayoutAlign="flex-end flex-start" fxFlex="50" style="padding-bottom: 18px">
        <mat-checkbox color="primary" formControlName="opportunityToEmployDirectly">{{'CLIENT.COMPANY_ADDITIONAL_INFO_OPTIONS.OPPORTUNITY_TO_EMPLOY_DIRECTLY' | translate}}</mat-checkbox>

        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
          <mat-checkbox color="primary" formControlName="orderCanBeExtended">{{'CLIENT.COMPANY_ADDITIONAL_INFO_OPTIONS.ORDER_CAN_BE_EXTENDED' | translate}}<app-field-destination field="orderCanBeExtended"></app-field-destination></mat-checkbox>

          <mat-form-field>
            <input matInput formControlName="orderCanBeExtendedComment">
          </mat-form-field>
        </div>

        <mat-checkbox color="primary" formControlName="canEmployUa">{{'CLIENT.COMPANY_ADDITIONAL_INFO_OPTIONS.CAN_EMPLOY_UKRAINIANS' | translate}}<app-field-destination field="canEmployUa"></app-field-destination></mat-checkbox>

        <mat-form-field appearance="outline" *ngIf="orderType === orderTypes.selection" fxFlexOffset="10px">
          <mat-label>{{'ORDER.CANDIDATES_TO_BE_PROVIDED' | translate}}<app-field-destination field="candidatesToBeProvided"></app-field-destination></mat-label>
          <input formControlName="candidatesToBeProvided" matInput>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
